import { render } from "./OrganismsDetailChart.vue?vue&type=template&id=16274a0a&ts=true"
import script from "./OrganismsDetailChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsDetailChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/organisms/OrganismsDetailChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16274a0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16274a0a', __exports__)) {
    api.reload('16274a0a', __exports__)
  }
  
  module.hot.accept("./OrganismsDetailChart.vue?vue&type=template&id=16274a0a&ts=true", () => {
    api.rerender('16274a0a', render)
  })

}


export default __exports__